export default {
      id: "board-usage",
      viewBox: "0 0 78.92 31.64",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#board",
      toString: function () {
        return this.url;
      }
    }